<frontend-pull-refresh></frontend-pull-refresh>

<section class="pb-3 pl-3">
  <div class="pt-1" *ngIf="user">
    <ngb-alert [dismissible]="false" *ngIf="user.account && user.account.subscriptionType === subscriptionTypes.offline" type="info" class="text-center mt-3">
      <div class="d-flex flex-row justify-content-center align-items-center">
        <tr-icon [icon]="icon.info" classes="pr-2"></tr-icon>

        <p class="my-0">{{locations.length}}/{{user.account.licenses}} location licenses are used</p>
      </div>
    </ngb-alert>

    <ngb-alert [dismissible]="false" *ngIf="bannedLocations !== ''" class="text-center">
      {{ bannedLocations }} location(s) has been disabled by the SMS spam checker. TablesReady support will review the circumstances within 24 hours.
    </ngb-alert>

    <div class="d-flex flex-row justify-content-between mb-2 pt-1 pr-2">
      <button
        *ngIf="showAddButton(user)"
        [style.min-width.px]="114"
        class="btn btn-info mr-3" (click)="addLocation()"
      >&#43; Add location</button>

      <tablesready-search-bar
        placeholder="Search location info"
        (search)="setFilters({ info: $event })"
      ></tablesready-search-bar>
    </div>

    <div class="table-wrapper" *ngIf="user.account">
      <table class="table tr-table table-bottom-spacer">
        <thead>
        <tr>
          <th>Name</th>
          <th class="text-center">Users</th>
          <th class="text-center">Waitlisted Parties</th>
          <th class="text-center">Estimated Wait</th>
          <th class="text-center filter-wide">
            <frontend-dropdown
              [searchable]="false"
              [clearable]="true"
              [items]="dropdownPricePlans"
              [(ngModel)]="selectedPlan"
              (ngModelChange)="setFilters({planCode: $event})"
              customClass="old-filter-style"
              placeholder="Subscription plan"
              bindLabel="title"
              bindValue="value"
              maxListHeight="9.3rem"
            ></frontend-dropdown>
          </th>
          <th class="text-center filter-wide">
            <frontend-dropdown
              [searchable]="false"
              [clearable]="true"
              [items]="availabilityFilters"
              [(ngModel)]="availabilityFilter"
              (ngModelChange)="setFilters({availability: $event})"
              customClass="old-filter-style"
              placeholder="Availability"
              bindLabel="title"
              bindValue="value"
            ></frontend-dropdown>
          </th>
          <th class="text-center">Actions</th>
        </tr>
        </thead>
        <tbody *ngIf="locations.length > 0; else noLocations">
        <tr *ngFor="let location of locations | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize; trackBy: trackById">
          <td>
            <tablesready-location-name-column
              [location]="location"
              [currentLocationId]="currentLocationId"
              [email]="user.email"
            ></tablesready-location-name-column>
          </td>
          <td class="text-center">
            <a
              class="td-link"
              *ngIf="location.enabled"
              [innerText]="locationUsersMap[location._id] || 0"
              (click)="navigateToLocationPage(location._id, '/settings/location/users')"
            ></a>
            <span class="td-link td-link-disabled" *ngIf="!location.enabled" [innerText]="locationUsersMap[location._id] || 0"></span>
          </td>
          <td class="text-center" [innerText]="getWaitlistedPartiesByLocation(location._id)"></td>
          <td class="text-center" [innerText]="location.default_quoted_time"></td>
          <td class="text-center">
            <tablesready-sms-usage
              [subscriptionType]="user.account.subscriptionType"
              [pricePlan]="pricePlansMap[location?.recurly?.planCode]"
              [usage]="location.usage"
              [timezone]="location.timezone"
            ></tablesready-sms-usage>
          </td>
          <td class="text-center">
            <div class="d-flex justify-content-center align-items-center">
              <tablesready-switcher
                *ngIf="location"
                [id]="location._id"
                [(ngModel)]="location.enabled"
                [disabled]="location._id === currentLocationId && enabledLocationsCounter === 1 || allAccountLocationsCounter === 1 || locationsTogglesDisabled"
                (ngModelChange)="updateLocationAvailability(location)"
              ></tablesready-switcher>
            </div>
          </td>
          <td>
            <div class="col-lg-12 d-flex flex-column align-content-between">
              <div class="d-flex flex-row justify-content-between w-100">
                <button class="btn btn-icon btn-info mr-2" (click)="editLocation(location)">
                  <tr-icon [icon]="icon.edit" [color]="iconColor.white"></tr-icon>
                </button>

                <button
                  *ngIf="subscriptionType !== subscriptionTypes.offline"
                  class="btn btn-danger btn-remove w-100"
                  [class.btn-disabled]="location._id === currentLocationId && enabledLocationsCounter === 1"
                  [disabled]="location._id === currentLocationId && enabledLocationsCounter === 1 || allAccountLocationsCounter === 1"
                  (click)="deleteLocation(location._id)"
                >Delete</button>
              </div>

              <div class="mt-2">
                <button
                  class="btn btn-info-outline w-100"
                  (mousedown)="analyticsBtnColor.color = iconColor.white; analyticsBtnColor.generateStyles()"
                  (mouseleave)="analyticsBtnColor.color = iconColor.blue; analyticsBtnColor.generateStyles()"
                  (click)="navigateToLocationPage(location._id, '/analytics')"
                  [disabled]="!location.enabled"
                >
                    <span class="d-flex flex-row justify-content-between align-items-center">
                      <p class="text-info mb-0">Analytics</p>
                      <tr-icon
                        #analyticsBtnColor
                        [icon]="icon.externalLink"
                        [color]="iconColor.blue"
                      ></tr-icon>
                    </span>
                </button>
              </div>

              <div class="mt-2">
                <button class="btn btn-outline-success w-100" (click)="copySettings(location._id)">Copy settings</button>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex flex-row justify-content-end">
      <div class="paginator pr-3" *ngIf="locations.length > 0">
        <ngb-pagination
          [(page)]="page"
          [pageSize]="pageSize"
          [maxSize]="maxSize"
          [ellipses]="true"
          [collectionSize]="locations.length"
        ></ngb-pagination>
      </div>
    </div>
  </div>

  <ng-template #noLocations>
    <div class="no-locations mt-2">
      <h2>No locations found</h2>
    </div>
  </ng-template>

</section>
